module.exports = __webpack_public_path__ + "img/ES.f2eaa9cc.svg";